import { useState } from 'react';
import { Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { Icon } from '@/components/Icon';
import colors from '@/config/colors';
import dependencies from '@/assets/dependencies.json';
import { Section } from './Section';
import { SECTION_DATA } from './data';
import ProductInformations from '../ProductInformations/ProductInformations';

function AboutNeolexon() {
  const [expanded, setExpanded] = useState(false);

  return (
    <View className="flex-1 w-full p-4">
      {SECTION_DATA.map((section, index) => {
        const hasChildren = !!section.children;
        return (
          <Section key={index} title={section.title} content={section.content}>
            {hasChildren ? (
              <section.children.Component
                {...section.children.componentProps}
              ></section.children.Component>
            ) : null}
          </Section>
        );
      })}
      <Section
        title="Eingesetzte Software-Komponenten"
        bodyNode={
          <>
            <Text className="text-lg text-slate-700">
              Im Folgenden finden Sie eine Übersicht der verwendeten
              Software-Komponenten von Drittanbietern. Diese sind erforderlich,
              um bestimmte Funktionen bereitzustellen und den sicheren und
              zuverlässigen Betrieb der Anwendung zu gewährleisten.
            </Text>
            <Pressable onPress={() => setExpanded((v) => !v)}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Text className="text-lg text-slate-700">
                  {expanded ? 'Ausblenden' : 'Anzeigen'}
                </Text>
                <Icon
                  name={expanded ? 'chevronDown' : 'chevronRight'}
                  size={20}
                  color={colors.newUI.therapist.primaryBlue80}
                />
              </View>
            </Pressable>
            {expanded ? (
              <View style={{ marginTop: 8 }}>
                {dependencies.map((dep) => (
                  <Text key={dep} className="text-lg text-slate-700">
                    {'• '}
                    {dep}
                  </Text>
                ))}
              </View>
            ) : null}
          </>
        }
      />
      <ProductInformations />
    </View>
  );
}

export default AboutNeolexon;
